import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .select {
      &:not(:last-of-type) {
         margin-bottom: 10px;
      }
      h4 { width: 88px; }
   }
   .textInput {
      h4 {
         width: 77px;
         min-width: 77px;
      }
      &:not(:last-of-type) {
         margin-bottom: 10px;
      }
   }
   > .scroll {
      overflow: auto;
      height: 202px;
      padding-right: 10px;
   }
   .action {
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1.line {
         margin-bottom: 0;
         &::after { display: none; }
      }
      .withBorder { margin-left: 7.5px; }
   } 
`;